<div class="confirmation-dialog" data-testid="cancel-success-dialog">
  <div class="dialog-title-bar">
    <h2 class="dialog-title" data-testid="cancel-success-dialog-title">Cancel Job</h2>
    <button class="close-btn" type="button" aria-label="Close dialog" (click)="onClose()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-body" data-testid="cancel-success-dialog-content">
    <img
      class="success-icon"
      src="assets/icons/success.svg"
      alt=""
      aria-hidden="true"
    />
    <p class="success-title">Success!</p>
    <p class="success-message">The translation job has been cancelled.</p>
  </mat-dialog-content>
</div>
